<template>
  <div class="learning">
    <div>
      <p class="text-h6">eラーニング</p>
      <span>動画で学習し、更に健康への意識を高めましょう！</span>
      <div class="text-center" v-if="isLoading">
        <v-progress-circular indeterminate color="secondary" />
      </div>
      <div class="learning-table mt-8 ma-md-8" v-if="!isLoading">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th :colspan="headerColSpan">eラーニング動画</th>
              </tr>
            </thead>
            <tbody v-if="learnings.length > 0">
              <tr v-for="learning of learnings" :key="learning.id">
                <td class="py-5">{{learning.theme_title}}</td>
                <template v-for="section of learning.sections">
                  <td :key="`${learning.theme_id}-${section.section_id}`">
                    <a @click="createLearningWatch(section)" @click.middle.prevent.stop="createLearningWatch(section)" style="text-decoration: none;" v-if="section.section_id">
                      <span style="text-decoration: underline;">{{section.link_display}}</span>
                      <v-icon class="ml-2" style="text-decoration: none;">
                        mdi-open-in-new
                      </v-icon>
                    </a>
                  </td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <!--共通コンポーネント-->
    <Dialog ref="confirm"/>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const Dialog = () => import('../util/Dialog.vue')
const listLearningThemeQuery = (campaignId) => `
  query listLearningTheme {
    listLearningTheme(
      campaign_id: "${campaignId}"
      ) {
      learnings {
        theme_id
        theme_title
        sections {
          section_id
          learning_id
          link_display
          youtube_url
        }
      }
    }
  }
`
const getListLearningThemeQuery = async (campaignId) => {
  const { data: { listLearningTheme: data } } = await GraphqlAPI(listLearningThemeQuery(campaignId))
  return data
}
const entrycreateWatch = (campaignId, learningId) => `
  mutation createWatch {
    createWatch(
      campaign_id: "${campaignId}"
      learning_id: "${learningId}"
    )
  }
`
const createWatch = async (campaignId, learningId) => {
  const { data: { createWatch: data } } = await GraphqlAPI(entrycreateWatch(campaignId, learningId))
  return data
}
export default {
  name: 'learning',
  components: {
    Dialog
  },
  data () {
    return {
      learnings: [],
      maxSect: 0,
      option: {
        maskPattern: 0,
        margin: 5,
        scale: 2,
        width: 130
      },
      isLoading: false,
      isMobileApp: false
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    },
    headerColSpan () {
      return this.isMobile ? (1 + this.maxSect) : (1 + this.maxSect * 2)
    }
  },
  async created () {
    await this.fetchListLearning()
    this.isMobileApp = this.$store.getters.getIsMobileApp
  },
  methods: {
    async fetchListLearning () {
      try {
        this.isLoading = true
        const listLearningResult = await getListLearningThemeQuery(this.campaign.id)
        for (const learning of listLearningResult.learnings) {
          // path末尾とテーマID先頭が一致するもののみ、表示対象とする
          if (learning.theme_id.toString().startsWith(this.$route.name.slice(-1))) {
            this.learnings.push(learning)
          }
        }
        for (const learning of this.learnings) {
          if (learning.sections.length > this.maxSect) {
            this.maxSect = learning.sections.length
          }
        }
        for (const learning of this.learnings) {
          if (learning.sections.length < this.maxSect) {
            for (let cnt = 0; cnt < (this.maxSect - learning.sections.length); cnt++) {
              learning.sections.push({})
            }
          }
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.$emit('errorHandling', 'eラーニングの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async createLearningWatch (section) {
      try {
        if (section.youtube_url) {
          this.isLoading = true
          if (!this.isMobileApp) {
            window.open(section.youtube_url, '_blank')
          }
          await createWatch(this.campaign.id, section.learning_id)
        }
      } catch (e) {
        this.$emit('errorHandling', '視聴ログの保存に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      } finally {
        this.isLoading = false
        if (this.isMobileApp) { // モバイルアプリの時は視聴ログ作成後（失敗しても）遷移
          window.open(section.youtube_url, '_self')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.learning-table > .v-data-table ::v-deep td {
  border-bottom: 1px solid #c4c4c4 !important;
}
</style>
